import { Box, Typography } from '@mui/material';

const Footer = () => {
    // Function to get the current year
    const getCurrentYear = () => {
        const date = new Date();
        return date.getFullYear();
    };

    return (
        <Box sx={{
            py: 3,
            px: 3,
            mt: 'auto',
            // Adjusted gradient to start completely transparent and transition to a solid dark emerald
            background: 'linear-gradient(180deg, rgba(6, 78, 59, 0) 0%, #171717 100%)',
            color: 'white',
            textAlign: 'center',
            fontFamily: "'Lora', serif",
        }}>
            <Typography variant="body2" sx={{ fontFamily: "'Lora', serif" }}>
                © {getCurrentYear()} VRILLER. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;
